import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace MigratedPoliciesActions {
    export class GetListPage {
        static readonly type = 'MigratedPoliciesActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class GetMigratedPolicyById {
        static readonly type = 'MigratedPoliciesActions.GetMigratedPolicyById';

        constructor(public id: number) {
        }
    }

    export class CancelPolicy {
        static readonly type = 'MigratedPoliciesActions.CancelPolicy';

        constructor(public policyId: number) {
        }
    }

    export class OpenCancelPolicyModal {
        static readonly type = 'MigratedPoliciesActions.OpenCancelPolicyModal';
    }

    export class GetInstallmentsAndClaims {
        static readonly type = 'MigratedPoliciesActions.GetInstallmentsAndClaims';
    }

    export class ClearPolicyData {
        static readonly type = 'MigratedPoliciesActions.ClearPolicyData';
    }

    export class ClearListItems {
        static readonly type = 'MigratedPoliciesActions.ClearListItems';
    }

    export class ClearList {
        static readonly type = 'MigratedPoliciesActions.ClearList';
    }
}
